import { gql } from "@outschool/ui-apollo";

export const ActivityFragment = gql`
  fragment ActivityFragment on Activity {
    uid
    slug_id
    user_uid
    title
    titleTranslated
    url
    path
    class_experience
    learning_goals
    assessment
    homework
    grading_policy
    prerequisites
    published_at
    is_online
    age_min
    age_max
    proficiency_level {
      level
      text
    }
    grade_level_min
    grade_level_max
    size_min
    size_max
    duration_minutes
    duration_weeks
    weekly_meetings
    price_cents
    summary
    summaryTranslated
    is_ongoing_weekly
    subject
    refundPolicy {
      name
      description
      type
    }
    details {
      photo
    }
    languageOfInstruction
    summaryForLearners
    allowWaitlist
    isClub
    isAutoSchedulingEnabled
    autoSchedulingDaysNoticeMin
    autoSchedulingDaysNoticeMax
    allows_recurring_payment
    allows_late_enrollment
    has_building_content
    hasTeacherSchedule
    isFlexSchedule
    isOneTime
  }
`;
